import { put, takeEvery, call, all, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'

// import group services
import { getProjects, postProject, putProject, deleteProject } from '../../services/project'

const getCurrentUser = state => state.user

export function* fetchProjects() {
  try {
    const user = yield select(getCurrentUser)
    const { data } = yield call(() => getProjects(user.token))
    yield put({
      type: actions.FETCH_PROJECTS_SUCCESS,
      data,
    })
  } catch (error) {
    yield put({ type: actions.FETCH_PROJECTS_ERROR, message: error.message })
  }
}

export function* setProject(project) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    project.payload.userMaster = JSON.parse(project.payload.userMaster)
    project.payload.userId = project.payload.userMaster.userId
    project.payload.userUid = project.payload.userMaster.userUid

    // ajusta los json
    project.payload.datetimedatajson = JSON.parse(project.payload.datetimedatajson)
    project.payload.sysdatajson = JSON.parse(project.payload.sysdatajson)
    project.payload.extradatajson = JSON.parse(project.payload.extradatajson)
    project.payload.operdatajson = JSON.parse(project.payload.operdatajson)
    project.payload.details = JSON.parse(project.payload.details)

    // agrego la empresa a sysdatajson
    project.payload.sysdatajson.companyUid = user.suscription.company.uid

    yield call(() => putProject(user.token, project.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se han guardado exitósamente los cambios',
    })
    yield put({
      type: actions.FETCH_PROJECTS,
    })
  } catch (error) {
    yield put({ type: actions.PROJECT_ERROR, message: error.message })
  }
}

export function* addProject(project) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    console.log('payload', project.payload)
    project.payload.userMaster = JSON.parse(project.payload.userMaster)
    project.payload.userId = project.payload.userMaster.userId
    project.payload.userUid = project.payload.userMaster.userUid

    // console.log('project:', project.payload);

    // ajusta los json
    // project.payload.datetimedatajson = JSON.parse( project.payload.datetimedatajson )
    project.payload.sysdatajson = JSON.parse(project.payload.sysdatajson)
    // project.payload.extradatajson    = JSON.parse( project.payload.extradatajson )
    // project.payload.operdatajson     = JSON.parse( project.payload.operdatajson )

    // agrego la empresa a sysdatajson
    project.payload.sysdatajson.companyUid = user.suscription.company.uid

    yield call(() => postProject(user.token, project.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se ha agregado exitósamente el proyecto',
    })
    yield put({
      type: actions.FETCH_PROJECTS,
    })
  } catch (error) {
    yield put({ type: actions.PROJECT_ERROR, message: error.message })
  }
}

export function* delProject(project) {
  try {
    const user = yield select(getCurrentUser)
    yield call(() => deleteProject(user.token, project.payload.uid))
    notification.success({
      message: 'Borrado exitoso',
      description: 'Se ha eliminado exitósamente el proyecto',
    })
    yield put({
      type: actions.FETCH_PROJECTS,
    })
  } catch (error) {
    yield put({ type: actions.PROJECT_ERROR, message: error.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_PROJECTS, fetchProjects),
    takeEvery(actions.PROJECT_SET, setProject),
    takeEvery(actions.PROJECT_ADD, addProject),
    takeEvery(actions.PROJECT_DEL, delProject),
  ])
}
